import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import colors from 'vuetify/es5/util/colors';
import { VuetifyThemeVariant } from 'vuetify/types/services/theme';
import { ThemeManager } from './themeManager';

Vue.use(Vuetify);

const darkTheme: VuetifyThemeVariant = {
  name: 'darkTheme',
  primary: colors.blue.darken1,
  secondary: colors.grey.darken1,
  accent: colors.blue.accent3,
  success: colors.green.base,
  error: colors.red.darken1,
  info: colors.blue.base,
  warning: colors.yellow.base,
};

const lightTheme: VuetifyThemeVariant = {
  background: colors.grey.darken4,
  backlight: colors.grey.lighten2,
  primary: colors.blue.darken1,
  secondary: colors.grey.darken1,
  accent: colors.blue.accent3,
  success: colors.green.base,
  error: colors.red.darken1,
  info: colors.blue.base,
  warning: colors.orange.darken3,
};

const vuetify = new Vuetify();
vuetify.framework.icons.iconfont = 'md';
vuetify.framework.theme.dark = ThemeManager.getInstance().getCurrentTheme();
vuetify.framework.theme.themes.light = lightTheme;
vuetify.framework.theme.themes.dark = darkTheme;
vuetify.framework.theme.options.customProperties = true;

export default vuetify;
